<template>
	<div>
		<spinner v-if="budget.loading"/>
		<div v-else class="idi-table budgets">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.budget') }}</div>
				<div class="idi-cell">{{ $t('labels.general.amount') }}</div>
			</div>
			<div class="idi-row" v-if="budget.hasData()">
				<div class="idi-cell">
					<span>{{ budget.data.id }}</span>
				</div>
				<div class="idi-cell">
					<span>My budget</span>
				</div>
				<div class="idi-cell">
					<span>{{ budget.data.current }}€</span>
				</div>
			</div>
			<div class="idi-row-empty" v-else>
				<div class="idi-cell">{{ $t('labels.general.empty') }}</div>
			</div>
		</div>
		<!--pre>{{ budget }}</pre-->
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			budget: new ApiObject()
		}
	},
	methods: {
		getBudget () {
			this.budget.loading = true
			this.$api.subscriptions.budgets.get(this, this.user_uid)
				.then(response => {
					this.$log.info('subscriptions', 'subscriptions.budgets.get OK', response)()
					this.budget.data = response.body
				}).catch(error => {
					this.$log.error('subscriptions', 'subscriptions.budgets.get ERROR', error)()
					this.budget.error = error
				}).finally(() => {
					this.budget.loading = false
				})
		}
	},
	mounted () {
		this.getBudget()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/Budget.vue